<div class="kyc-modal">
  <div class="container status" *ngIf="isLoadingRetries" style="min-height: 300px; display: flex; justify-content: center; align-items: center;">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  <ng-container *ngIf="!isLoadingRetries">
  <!-- RETRY INFO BANNER (above header) -->
  <div class="retry-info-banner" *ngIf="serverCurrentRetries > 0 && serverMaxRetries > 0 && steps !== 'ERROR' && steps !== 'SUCCESS' && steps !== 'RETRY_LIMIT_EXCEEDED' && steps !== 'END_PROCESSING' && steps !== 'BLOCKED' && steps !== 'REVIEW'">
    <div class="retry-info-content">
      <mat-icon>info</mat-icon>
      <span>
        {{ "Verification attempts" | translate }}:
        <strong>{{ serverCurrentRetries }} / {{ serverMaxRetries }}</strong>
      </span>
    </div>
  </div>

  <!-- HEADER -->
  <div class="header" *ngIf="steps !== 'ERROR' && steps !== 'SUCCESS' && steps !== 'RETRY_LIMIT_EXCEEDED' && steps !== 'BLOCKED' && steps !== 'REVIEW'">
    <div class="start">
      <mat-icon>
        {{
          steps === "TYPE-DOC"
            ? "description"
            : steps === "UPLOAD"
            ? "cloud_upload"
            : steps === "PROCESSING"
            ? "hourglass_empty"
            : steps === "IFRAME_VALIDATION"
            ? "security"
            : steps === "END_PROCESSING"
            ? "check_circle"
            : ""
        }}
      </mat-icon>
      <h3 class="title">
        {{
        (steps === "TYPE-DOC"
        ? "Select the type of document"
        : steps === "UPLOAD"
  ? ("Upload your document - " | translate) +
  (getDocumentTypeLabel(documentType!) | translate)
        : steps === "PROCESSING"
        ? "Checking your document..."
        : steps === "IFRAME_VALIDATION"
        ? "Complete your verification"
        : steps === "END_PROCESSING"
        ? "Waiting for approval"
        : ""
        ) | translate
        }}
      </h3>
    </div>

    <div class="end">
      <mat-icon
        *ngIf="!data.isComponentView"
        (click)="confirmClose()"
        data-testid="kyc-modal-close"
        >close</mat-icon
      >
    </div>
  </div>

  <!-- BRDOCS guided capture (replaces TYPE-DOC + UPLOAD for opted-in providers) -->
  <ng-container *ngIf="useBrdocsCapture && (steps === 'TYPE-DOC' || steps === 'UPLOAD')">
    <div class="brdocs-capture-host">
      <brdocs-capture-flow #brdocsFlow [embedded]="true" [manualFallbackMs]="manualFallbackMs" [documentCheck]="documentCheck" (completed)="onBrdocsCompleted($event)" (action)="onBrdocsAction($event)" (debug)="onBrdocsDebug($event)" (cameraStarted)="onBrdocsCameraStarted($event)"></brdocs-capture-flow>
    </div>
  </ng-container>

  <!-- STEP 1: TYPE-DOC -->
  <ng-container *ngIf="!useBrdocsCapture && steps === 'TYPE-DOC'">
    <div class="container typedoc">
      <input-text-select [(ngModel)]="documentType" id="doctype" name="doctype"
        label="{{ 'Document Type' | translate }}" [options]="options" />
      <p class="text">
        {{ getProviderPrivacyNotice() }}
      </p>

      <!-- Custom content for specific providers -->
      <ng-content select="[provider-type-doc-content]"></ng-content>
    </div>
    <div class="footer">
      <button class="def-button alt" *ngIf="!data.isComponentView" (click)="close()">
        {{ "Cancel" | translate }}
      </button>
      <button class="def-button quede" (click)="nextStep()" [disabled]="!documentType">
        {{ "Next" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- STEP 2: UPLOAD -->
  <ng-container *ngIf="!useBrdocsCapture && steps === 'UPLOAD'">
    <div class="container upload">
      <!-- B2b/B3b Veriff Reading Error Banner -->
      <div *ngIf="isVeriffReadingError" class="veriff-reading-error-banner">
        <mat-icon>info</mat-icon>
        <div class="banner-content">
          <p class="banner-description">
            {{ 'REUPLOAD_VERIFF_READING_ERROR_DESCRIPTION' | translate }}
          </p>
          <p class="banner-instruction">
            {{ 'REUPLOAD_VERIFF_READING_ERROR_INSTRUCTION' | translate }}
          </p>
        </div>
      </div>

      <!-- Display validation errors if any -->
      <div *ngIf="currentError" class="error-banner">
        <mat-icon>error</mat-icon>
        <div class="error-content">
          <!-- Card de erro de processamento (exibe tanto em UPLOAD quanto em PROCESSING) -->
          <div *ngIf="hasProcessingError && currentError" class="processing-error-card">
            <div class="error-content">
              <p class="error-message">
                {{ currentError.message }}
              </p>

              <p class="error-suggestion" *ngIf="currentError.suggestedAction">
                {{ currentError.suggestedAction }}
              </p>

              <!-- Wait timer display -->
              <div *ngIf="currentError.shouldWait && isWaitTimeActive()" class="error-wait-timer">
                <mat-icon>schedule</mat-icon>
                <span>{{ "Please wait" | translate }}: {{ formatWaitTime() }}</span>
              </div>
            </div>

            <div class="error-actions">
              <!-- Retry button with conditional logic -->
              <ng-container *ngIf="currentError.canRetry">
                <!-- shouldWait=true: disabled button with timer -->
                <button *ngIf="currentError.shouldWait" class="def-button wait-button small" [disabled]="isWaitTimeActive()"
                  (click)="processError()">
                  <span *ngIf="isWaitTimeActive()">
                    {{ "Wait" | translate }} {{ formatWaitTime() }}
                  </span>
                  <span *ngIf="!isWaitTimeActive()">
                    {{ "TryAgain" | translate }}
                  </span>
                </button>

                <!-- shouldWait=false: normal retry button -->
                <button *ngIf="!currentError.shouldWait" class="def-button small" (click)="processError()">
                  {{ "TryAgain" | translate }}
                </button>
              </ng-container>

              <!-- Cancel button -->
              <button class="def-button alt small" *ngIf="!data.isComponentView" (click)="close()">
                {{ "Cancel" | translate }}
              </button>

              <!-- Agent bypass: visible only in impersonation sessions when check is stuck waiting -->
              <button
                *ngIf="isAgentSession && currentError.shouldWait"
                class="def-button alt small"
                data-testid="kyc-bypass-stuck-wait"
                [disabled]="agentActionLoading !== null"
                (click)="onAgentBypassKyc()">
                <mat-icon class="btn-loading-icon" [style.visibility]="agentActionLoading === 'bypass' ? 'visible' : 'hidden'">hourglass_empty</mat-icon>
                {{ 'KYC.AGENT_ACTIONS.BYPASS_KYC' | translate }}
              </button>
            </div>

            <p class="faq-link">
              {{ "NeedHelp?CheckOur" | translate }} <a (click)="goToFaq()">FAQ</a>
            </p>
          </div>
          <strong>{{ getCurrentErrorMessage() | translate }}</strong>
          <p *ngIf="currentError.suggestedAction">{{ currentError.suggestedAction }}</p>
        </div>
      </div>

      <!-- Single upload for Passport -->
      <ng-container *ngIf="documentType === DocumentType.PASSPORT">
        <app-input-upload-file [enablePdfPreview]="true" class="single-upload" [fileSrc]="frontImage || ''" maxHeight="200px"
          [hasTitleDeleteImg]="false" [deleteButtonDisposition]="'vertical'"
          [acceptedFormats]="'image/jpeg,application/pdf'"
          [maxFileSizeMB]="50"
          (file)="changeImage($event, 'front')"
          (photoButtonClick)="onKycPhotoButtonClick()"
          (uploadButtonClick)="onKycUploadButtonClick()"></app-input-upload-file>
      </ng-container>

      <!-- CNH Type Toggle (drivers_license and id_card on verifflite) -->
      <div class="cnh-toggle-container" *ngIf="showCnhToggle">
        <h4 class="cnh-instruction-type-document">
          {{ "CNH.InstructionTypeDocument" | translate }}
        </h4>
        <mat-button-toggle-group [(ngModel)]="cnhType" class="cnh-toggle-group">
          <mat-button-toggle value="digital" (click)="onCnhTypeChange('digital')">
            <mat-icon>smartphone</mat-icon>
            <span>{{ 'CNH.DigitalTitle' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle value="physical" (click)="onCnhTypeChange('physical')">
            <mat-icon>badge</mat-icon>
            <span>{{ 'CNH.PhysicalTitle' | translate }}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <!-- CNH Instructions Box - Single Column -->
      <div class="cnh-instructions-box-single" *ngIf="showCnhToggle">
        <!-- Digital CNH -->
        <div class="cnh-column digital" *ngIf="cnhType === 'digital'">
          <div class="cnh-header">
            <mat-icon>smartphone</mat-icon>
            <h4>{{ 'CNH.DigitalTitle' | translate }}</h4>
          </div>
          <div class="cnh-content">
            <p class="cnh-subtitle">{{ 'CNH.HowTo' | translate }}</p>
            <ol class="cnh-steps">
              <li>{{ 'CNH.Digital.Step1' | translate }}</li>
              <li>{{ 'CNH.Digital.Step2' | translate }}</li>
              <li>{{ 'CNH.Digital.Step3' | translate }}</li>
            </ol>
            <p class="cnh-tips-title">{{ 'CNH.Tips' | translate }}</p>
            <ul class="cnh-tips">
              <li>{{ 'CNH.Digital.Tip1' | translate }}</li>
              <li>{{ 'CNH.Digital.Tip2' | translate }}</li>
            </ul>
          </div>
        </div>

        <!-- Physical CNH -->
        <div class="cnh-column physical" *ngIf="cnhType === 'physical'">
          <div class="cnh-header">
            <mat-icon>badge</mat-icon>
            <h4>{{ 'CNH.PhysicalTitle' | translate }}</h4>
          </div>
          <div class="cnh-content">
            <ul class="cnh-tips">
              <li>{{ 'CNH.Physical.Tip1' | translate }}</li>
              <li>{{ 'CNH.Physical.Tip2' | translate }}</li>
              <li>{{ 'CNH.Physical.Tip3' | translate }}</li>
              <li>{{ 'CNH.Physical.Tip4' | translate }}</li>
              <li>{{ 'CNH.Physical.Tip5' | translate }}</li>
              <li>{{ 'CNH.Physical.Tip6' | translate }}</li>
            </ul>
            <!-- <div class="cnh-gif-container">
              <img src="assets/img/cnh-physical.gif" alt="CNH Physical Example" class="cnh-gif">
              <p class="cnh-gif-caption">{{ 'CNH.Physical.UnfoldDocument' | translate }}</p>
            </div> -->
            <div class="cnh-warning">
              <mat-icon>warning</mat-icon>
              <span>{{ 'CNH.Physical.Warning' | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Single upload for CNH/ID (drivers_license and id_card on verifflite) -->
      <ng-container *ngIf="showCnhToggle && cnhType">
        <div class="single-upload-cnh">
          <h4 class="upload-title">
            {{ "CNH.SelectFile" | translate }}
          </h4>
          <app-input-upload-file [enablePdfPreview]="true" class="image-upload" [fileSrc]="frontImage || ''" maxHeight="200px"
            [hasTitleDeleteImg]="false" [deleteButtonDisposition]="'vertical'"
            [acceptedFormats]="cnhType === 'digital' ? 'application/pdf' : 'image/jpeg,application/pdf'"
            [maxFileSizeMB]="50"
            (file)="changeImage($event, 'front')"
            (photoButtonClick)="onKycPhotoButtonClick()"
            (uploadButtonClick)="onKycUploadButtonClick()"></app-input-upload-file>
        </div>
      </ng-container>

      <!-- Double upload for other documents (except CNH/ID on verifflite and Passport) -->
      <ng-container *ngIf="documentType !== null && documentType !== DocumentType.PASSPORT && !showCnhToggle">
        <div class="multiple-upload">
          <div class="side front">
            <h4 class="multiple-title">
              {{ "Upload a file" | translate }}
            </h4>
            <app-input-upload-file title="Front image" [enablePdfPreview]="true" class="image-upload" [fileSrc]="frontImage || ''" maxHeight="180px"
              [hasTitleDeleteImg]="false" [deleteButtonDisposition]="'vertical'"
              [acceptedFormats]="'image/jpeg,application/pdf'"
              [maxFileSizeMB]="50"
              (file)="changeImage($event, 'front')"
              (photoButtonClick)="onKycPhotoButtonClick()"
              (uploadButtonClick)="onKycUploadButtonClick()"></app-input-upload-file>
          </div>
          <div class="side back">
            <h4 class="multiple-title">
              {{ "Upload a file" | translate }}
            </h4>
            <app-input-upload-file title="Back image" [enablePdfPreview]="true" class="image-upload" [fileSrc]="backImage || ''" maxHeight="180px"
              [hasTitleDeleteImg]="false" [deleteButtonDisposition]="'vertical'"
              [acceptedFormats]="'image/jpeg,application/pdf'"
              [maxFileSizeMB]="50"
              (file)="changeImage($event, 'back')"
              (photoButtonClick)="onKycPhotoButtonClick()"
              (uploadButtonClick)="onKycUploadButtonClick()"></app-input-upload-file>
          </div>
        </div>
      </ng-container>

      <!-- Display validation warnings -->
      <div *ngIf="
          frontValidation &&
          frontValidation.warnings &&
          frontValidation.warnings.length > 0
        " class="warnings-list">
        <div *ngFor="let warning of frontValidation.warnings" class="warning-item">
          <mat-icon>warning</mat-icon>
          <span>{{ warning.message }}</span>
        </div>
      </div>
      <div *ngIf="
          backValidation &&
          backValidation.warnings &&
          backValidation.warnings.length > 0
        " class="warnings-list">
        <div *ngFor="let warning of backValidation.warnings" class="warning-item">
          <mat-icon>warning</mat-icon>
          <span>{{ warning.message }}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="def-button alt" (click)="backStep()">
        {{ "Back" | translate }}
      </button>
      <button class="def-button" data-testid="kyc-upload-next" [disabled]="!frontImage || (showCnhToggle && !cnhType) || (requiresBackImage && !backImage)" (click)="nextStep()">
        {{ "Next" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- STEP 4: PROCESSING -->
  <ng-container *ngIf="steps === 'PROCESSING'">
    <div class="container processing">
      <!-- Indeterminate progress bar -->
      <mat-progress-bar mode="indeterminate" *ngIf="isProcessingIndeterminate && !hasProcessingError"></mat-progress-bar>

      <!-- Processing steps with checkmarks -->
      <div class="processing-steps">
        <div *ngFor="let step of processingSteps" class="processing-step" [class.done]="step.done"
          [class.active]="step.step === currentProcessingStep && !step.hasError && !step.actionNeeded"
          [class.action-needed]="step.actionNeeded && !step.hasError" [class.error]="step.hasError">
          <div class="step-icon">
            <!-- Step completed successfully -->
            <mat-icon *ngIf="step.done && !step.hasError">check_circle</mat-icon>

            <!-- Step with error -->
            <mat-icon *ngIf="step.hasError" class="error-icon">cancel</mat-icon>

            <!-- Step waiting on the user (SomosKycV1 name gate / CPF correction) -->
            <mat-icon *ngIf="step.actionNeeded && !step.done && !step.hasError" class="action-needed-icon">
              how_to_reg
            </mat-icon>

            <!-- Step in progress -->
            <mat-spinner
              *ngIf="!step.actionNeeded && !step.done && !step.hasError && step.step === currentProcessingStep"
              diameter="20"></mat-spinner>

            <!-- Step not started -->
            <mat-icon *ngIf="!step.done && !step.hasError && !step.actionNeeded && step.step !== currentProcessingStep">
              radio_button_unchecked
            </mat-icon>
          </div>
          <div class="step-message">
            <span class="step-label">{{
              step.message === 'Preparing documents for verification...'
                ? ('PreparingDocumentsForVerification' | translate)
                : step.message === 'Verifying your documents...'
                ? ('VerifyingYourDocuments' | translate)
                : (step.message | translate)
            }}</span>
            <!-- Muted sub-line under the active step (SomosKycV1 only — descriptionKey is unset elsewhere) -->
            <span class="step-hint"
              *ngIf="step.descriptionKey && step.step === currentProcessingStep && !step.hasError">
              {{ step.descriptionKey | translate }}
            </span>
          </div>
        </div>
      </div>

      <!-- Retry attempts indicator -->
      <div *ngIf="uploadAttempts > 1" class="retry-info">
        {{ "Retry attempt" | translate }}: {{ uploadAttempts }} /
        {{ retryConfig.maxAttempts }}
      </div>

      <!-- Hint shown when PROCESSING step takes longer than expected (e.g. provider fallback).
           SomosKycV1 intentionally omits it; all other providers keep the pre-SomosKycV1 behaviour. -->
      <div *ngIf="!isSomosV1 && currentProcessingStep === 'PROCESSING' && !hasProcessingError && processingElapsedSeconds >= 5"
           class="processing-taking-long-hint">
        <mat-icon>hourglass_top</mat-icon>
        <span>{{ 'KYCProcessingTakingLong' | translate }}</span>
      </div>

      <!-- Processing Error Card -->
      <ng-container *ngIf="hasProcessingError && currentError">

        <!-- CPF Correction Card (shown when CPF/DOB validation failed) -->
        <div *ngIf="currentError.validationType === 'cpf_validation'" class="processing-error-card cpf-correction-card">
          <div class="error-content">
            <p class="error-message">
              {{ currentError.message || ('KYC.ERROR.UNABLE_VALIDATE_CPF' | translate) }}
            </p>
            <p class="error-suggestion">
              {{ currentError.suggestedAction || ('KYC.ERROR.VERIFY_CPF_AND_DOB' | translate) }}
            </p>

            <div *ngIf="cpfCorrectionForm" class="cpf-correction-fields">
              <!-- SomosKycV1: CPF + name are editable (the registry validates all three fields). -->
              <div class="cpf-field-row" *ngIf="isSomosV1">
                <app-shared-form-input-text
                  [(ngModel)]="correctedName"
                  [ngModelOptions]="{ standalone: true }"
                  label="{{ 'Full Legal Name' | translate }}"
                  id="legalName"
                  name="legalName"
                ></app-shared-form-input-text>
              </div>
              <div class="cpf-field-row" *ngIf="isSomosV1">
                <app-shared-form-input-text
                  [(ngModel)]="correctedCpf"
                  [ngModelOptions]="{ standalone: true }"
                  label="{{ 'CPF' | translate }}"
                  id="cpf"
                  name="cpf"
                ></app-shared-form-input-text>
              </div>
              <!-- Other providers (verifflite/…): read-only CPF, edit DOB only (pre-SomosKycV1). -->
              <div class="cpf-field-row" *ngIf="!isSomosV1">
                <app-shared-form-input-text
                  [(ngModel)]="originalCpf"
                  [readonly]="true"
                  label="{{ 'CPF' | translate }}"
                  id="cpf"
                  name="cpf"
                ></app-shared-form-input-text>
              </div>
              <form [formGroup]="cpfCorrectionForm">
                <div class="cpf-field-row">
                  <input-date
                    formControlName="dob"
                    id="dob"
                    name="dob"
                    label="{{ 'Date of Birth' | translate }}"
                  ></input-date>
                  <span class="cpf-field-error"
                    *ngIf="cpfCorrectionForm.get('dob')?.invalid && cpfCorrectionForm.get('dob')?.dirty">
                    {{ 'InvalidDateOfBirth' | translate }}
                  </span>
                </div>
              </form>
            </div>

            <!-- Correction submit failed (e.g. /profile blocked): tell the user instead of dying silently -->
            <p class="cpf-field-error cpf-correction-submit-error" *ngIf="cpfCorrectionError">
              {{ cpfCorrectionError }}
            </p>
          </div>

          <div class="error-actions">
            <button
              class="def-button small"
              [disabled]="(isSomosV1 ? !canSubmitCpfCorrection : cpfCorrectionForm?.invalid) || isCpfCorrectionSubmitting"
              (click)="onCpfCorrectionRetry()">
              {{ isCpfCorrectionSubmitting ? ('Updating' | translate) : ('TryAgain' | translate) }}
            </button>
            <button class="def-button alt small" *ngIf="!data.isComponentView" (click)="close()">
              {{ "Cancel" | translate }}
            </button>
          </div>

          <p class="faq-link">
            {{ "NeedHelp?CheckOur" | translate }} <a (click)="goToFaq()">FAQ</a>
          </p>
        </div>

        <!-- Generic Processing Error Card (for non-CPF errors) -->
        <div *ngIf="currentError.validationType !== 'cpf_validation'" class="processing-error-card">
          <div class="error-content">
            <p class="error-message">
              {{ currentError.message }}
            </p>

            <p class="error-suggestion" *ngIf="currentError.suggestedAction">
              {{ currentError.suggestedAction }}
            </p>

            <!-- Retry limit info -->
            <div *ngIf="currentError.currentRetries !== undefined && currentError.maxRetries !== undefined"
                 class="retry-limit-info">
              <mat-icon>info</mat-icon>
              <span>
                {{ "Verification attempts" | translate }}:
                {{ currentError.currentRetries }} / {{ currentError.maxRetries }}
              </span>
            </div>

            <!-- Wait timer display -->
            <div *ngIf="currentError.shouldWait && isWaitTimeActive()" class="error-wait-timer">
              <mat-icon>schedule</mat-icon>
              <span>{{ "Please wait" | translate }}: {{ formatWaitTime() }}</span>
            </div>
          </div>

          <div class="error-actions">
            <!-- Retry button with conditional logic -->
            <ng-container *ngIf="currentError.canRetry">
              <!-- shouldWait=true: disabled button with timer -->
              <button *ngIf="currentError.shouldWait" class="def-button wait-button small" [disabled]="isWaitTimeActive()"
                (click)="processError()">
                <span *ngIf="isWaitTimeActive()">
                  {{ "Wait" | translate }} {{ formatWaitTime() }}
                </span>
                <span *ngIf="!isWaitTimeActive()">
                  {{ "TryAgain" | translate }}
                </span>
              </button>

              <!-- shouldWait=false: normal retry button -->
              <button *ngIf="!currentError.shouldWait" class="def-button small" (click)="processError()">
                {{ "TryAgain" | translate }}
              </button>
            </ng-container>

            <!-- Cancel button -->
            <button class="def-button alt small" *ngIf="!data.isComponentView" (click)="close()">
              {{ "Cancel" | translate }}
            </button>
          </div>

          <p class="faq-link">
            {{ "NeedHelp?CheckOur" | translate }} <a (click)="goToFaq()">FAQ</a>
          </p>
        </div>

      </ng-container>
    </div>
  </ng-container>

  <!-- STEP 5: IFRAME_VALIDATION (for Veriff) -->
  <ng-container *ngIf="steps === 'IFRAME_VALIDATION'">
    <div class="container iframe-validation">
      <!-- Custom content for iframe validation (used by Veriff) -->
      <ng-content select="[provider-iframe-content]"></ng-content>
    </div>
    <div class="footer central">
      <button class="def-button alt" *ngIf="!data.isComponentView" (click)="close()">
        {{ "Cancel" | translate }}
      </button>
      <ng-content select="[provider-iframe-actions]"></ng-content>
    </div>
  </ng-container>

  <!-- STEP 6: SUCCESS -->
  <ng-container *ngIf="steps === 'SUCCESS'">
    <div
      class="container status success"
      [class.under-review]="isPostpone"
      [attr.data-testid]="isPostpone ? 'kyc-under-review-card' : 'kyc-verified-card'"
    >
      <!-- CPK-3802: postpone with a configured block message renders it; else default UI -->
      <app-message-renderer
        *ngIf="isPostpone && postponeBlocks; else defaultSuccess"
        [doc]="postponeBlocks"
      ></app-message-renderer>
      <ng-template #defaultSuccess>
        <mat-icon>{{ isPostpone ? 'hourglass_empty' : 'check_circle' }}</mat-icon>
        <h3 class="title">
          {{
          postponeOffersRetry
          ? ("KycManualReviewChoiceTitle" | translate)
          : (isPostpone
          ? ("KycUnderReviewTitle" | translate)
          : (result.status === "VERIFIED"
          ? ("Identity Verified!" | translate)
          : ("Document Submitted Successfully!" | translate)))
          }}
        </h3>
        <p class="message" [class.consent]="postponeOffersRetry">
          {{
          postponeOffersRetry
          ? ("KycManualReviewChoiceMessage" | translate)
          : (isPostpone
          ? (postponeMessage || ("KycUnderReviewMessage" | translate))
          : ("identityVerified" | translate))
          }}
        </p>
        <p class="next-steps" *ngIf="result.status === 'PROCESSING' && !postponeOffersRetry">
          {{
          "We'll notify you once the verification is complete. This typically takes a few minutes."
          | translate
          }}
        </p>
      </ng-template>
    </div>
    <div class="footer central">
      <!-- TC6: a document-readability postpone offers an informed-consent choice —
           resubmit a clearer document, or refer the check to manual review. -->
      <ng-container *ngIf="postponeOffersRetry; else postponeProceed">
        <button
          class="def-button small"
          (click)="onPostponeResubmit()"
          data-testid="kyc-postpone-resubmit"
        >
          {{ "KycManualReviewChoiceRetry" | translate }}
        </button>
        <button
          class="def-button"
          (click)="onPostponeAcceptManualReview()"
          data-testid="kyc-postpone-manual-review"
        >
          {{ "KycManualReviewChoiceEscalate" | translate }}
        </button>
      </ng-container>
      <ng-template #postponeProceed>
        <!-- CPK-4807: postpone reopened from the outstanding action — resubmit while the
             client has retries left; "Fechar" instead of "Prosseguir" once they are spent. -->
        <button
          *ngIf="postponeFooter === 'retry'"
          class="def-button small"
          (click)="onPostponeResubmit()"
          data-testid="kyc-postpone-oa-retry"
        >
          {{ "KycManualReviewChoiceRetry" | translate }}
        </button>
        <button
          *ngIf="postponeFooter === 'close'; else postponeProceedButton"
          class="def-button"
          (click)="close()"
          data-testid="kyc-postpone-oa-close"
        >
          {{ "Close" | translate }}
        </button>
      </ng-template>
      <ng-template #postponeProceedButton>
        <button class="def-button" (click)="close()" data-testid="kyc-success-proceed">
          {{ "Proceed" | translate }}
        </button>
      </ng-template>
    </div>
  </ng-container>

  <!-- STEP 6b: REVIEW (compliance/watchlist block routed to manual review — terminal, NO button).
       Same card layout as the success/under-review terminal; renders per-action copy from the
       note's review_reason, or the default KycReview* i18n when the action configured none. -->
  <ng-container *ngIf="steps === 'REVIEW'">
    <div class="container status success under-review" data-testid="kyc-review-card">
      <!-- Block-based review message renders it; else the default title + message. -->
      <app-message-renderer
        *ngIf="reviewBlocks; else defaultReview"
        [doc]="reviewBlocks"
      ></app-message-renderer>
      <ng-template #defaultReview>
        <mat-icon>hourglass_empty</mat-icon>
        <h3 class="title" data-testid="kyc-review-title">
          {{ "KycReviewTitle" | translate }}
        </h3>
        <p class="message" data-testid="kyc-review-message">
          {{ reviewMessage || ("KycReviewMessage" | translate) }}
        </p>
      </ng-template>
    </div>
    <!-- Intentionally NO footer / action button: the case is under manual review. -->
  </ng-container>

  <!-- STEP 7: END_PROCESSING (Still reviewing — non-terminal, calm, closeable) -->
  <ng-container *ngIf="steps === 'END_PROCESSING'">
    <div class="container status success">
      <mat-icon>hourglass_empty</mat-icon>
      <h3 class="title">
        {{ "KycStillReviewingTitle" | translate }}
      </h3>
      <p class="message">
        {{ "KycStillReviewingMessage" | translate }}
      </p>
    </div>
    <div class="footer central">
      <!-- If the check actually died server-side the user would otherwise be stuck
           PENDING forever. Offer the same retry path the hard-failure state uses
           (processError), keeping the calm messaging, next to Close. -->
      <button
        class="def-button small"
        (click)="processError()"
        data-testid="kyc-still-reviewing-retry"
      >
        {{ "KycStillReviewingRetry" | translate }}
      </button>
      <button
        class="def-button"
        (click)="close()"
        data-testid="kyc-still-reviewing-close"
      >
        {{ "KycStillReviewingClose" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- STEP 8: RETRY_LIMIT_EXCEEDED  -->
  <ng-container *ngIf="steps === 'RETRY_LIMIT_EXCEEDED'">
    <div class="container status retry-limit">
      <mat-icon>block</mat-icon>
      <h3 class="title">
        {{ "RETRY_LIMIT_EXCEEDED" | translate }}
      </h3>
      <p class="message">
        {{ "You have reached the maximum number of verification attempts." | translate }}
      </p>

    <div class="retry-limit-info-large">
        <mat-icon>info</mat-icon>
        <div class="info-content">
          <p class="info-title">{{ "Verification attempts" | translate }}</p>
          <p class="info-value">{{ serverCurrentRetries }} / {{ serverMaxRetries }}</p>
        </div>
      </div>

      <!-- <p class="suggested-action">
        {{ "Please contact our support team for assistance with your verification." | translate }}
      </p> -->

      <p class="faq-link">
        {{ "NeedHelp?CheckOur" | translate }} <a (click)="goToFaq()">FAQ</a>
      </p>

      <!-- Agent Diagnostic Panel (only visible during impersonation) -->
      <div *ngIf="isAgentSession && agentDiagnostics" class="agent-diagnostic-panel">
        <h4>{{ 'KYC.AGENT_DIAGNOSTICS.TITLE' | translate }}</h4>
        <table>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.ERROR_CODE' | translate }}</td><td>{{ agentDiagnostics.errorCode }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.REASON_CODE' | translate }}</td><td>{{ agentDiagnostics.reasonCode }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.PROVIDER' | translate }}</td><td>{{ agentDiagnostics.provider }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.RETRIES' | translate }}</td><td>{{ agentDiagnostics.retries }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.PEP_SANCTIONS' | translate }}</td><td>{{ agentDiagnostics.pepSanctions === null ? ('KYC.AGENT_DIAGNOSTICS.NOT_CHECKED' | translate) : agentDiagnostics.pepSanctions ? ('KYC.AGENT_DIAGNOSTICS.YES' | translate) : ('KYC.AGENT_DIAGNOSTICS.NO' | translate) }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.NOTES_COUNT' | translate }}</td><td>{{ agentDiagnostics.notesCount }}</td></tr>
        </table>
        <details>
          <summary>{{ 'KYC.AGENT_DIAGNOSTICS.RAW_NOTES' | translate }}</summary>
          <pre>{{ agentDiagnostics.rawNotes }}</pre>
        </details>
        <!-- Underage notice (only when DOB indicates client is under 18) -->
        <div *ngIf="isUnderageClient" class="underage-notice">
          <span>{{ 'KYC.AGENT_ACTIONS.UNDERAGE_CLIENT_NOTICE' | translate }}</span>
        </div>

        <div class="agent-actions">
          <h4>{{ 'KYC.AGENT_ACTIONS.TITLE' | translate }}</h4>
          <button class="def-button small" (click)="onAgentIncreaseRetries()" [disabled]="agentActionLoading">
            <mat-icon class="btn-loading-icon" [style.visibility]="agentActionLoading === 'retries' ? 'visible' : 'hidden'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.INCREASE_RETRIES' | translate }}
          </button>

          <!-- Quando NÃO é menor de idade: botão padrão de bypass -->
          <button *ngIf="!isUnderageClient" class="def-button alt small" (click)="onAgentBypassKyc()" [disabled]="agentActionLoading">
            <mat-icon class="btn-loading-icon" [style.visibility]="agentActionLoading === 'bypass' ? 'visible' : 'hidden'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.BYPASS_KYC' | translate }}
          </button>

          <!-- Quando é menor de idade: botão para corrigir DOB (adiciona +1 tentativa) -->
          <button *ngIf="isUnderageClient" class="def-button alt small" (click)="onAgentFixDob()" [disabled]="agentActionLoading !== null">
            <mat-icon class="btn-loading-icon" [style.visibility]="agentActionLoading === 'retries' ? 'visible' : 'hidden'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.FIX_DOB' | translate }}
          </button>

          <!-- Quando é menor de idade: botão de bypass por menoridade -->
          <button
            class="def-button alt small"
            *ngIf="isUnderageClient"
            [disabled]="agentActionLoading !== null"
            (click)="onUnderageBypassKyc()">
            <mat-icon class="btn-loading-icon" [style.visibility]="agentActionLoading === 'bypass' ? 'visible' : 'hidden'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.UNDERAGE_BYPASS' | translate }} · {{ 'KYC.AGENT_ACTIONS.UNDERAGE_BYPASS_LABEL' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer central">
      <button class="def-button alt" *ngIf="!data.isComponentView" (click)="close()">
        {{ "Close" | translate }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="steps === 'BLOCKED'">
    <div class="container status blocked">
      <mat-icon>schedule</mat-icon>
      <h3 class="title">
        {{ "KYC.BLOCKED.TITLE" | translate }}
      </h3>
      <p class="message">
        {{ "KYC.BLOCKED.MESSAGE_LINE1" | translate }}
      </p>

      <!-- Agent Diagnostic Panel (only visible during impersonation) -->
      <div *ngIf="isAgentSession && agentDiagnostics" class="agent-diagnostic-panel">
        <h4>{{ 'KYC.AGENT_DIAGNOSTICS.TITLE' | translate }}</h4>
        <table>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.ERROR_CODE' | translate }}</td><td>{{ agentDiagnostics.errorCode }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.REASON_CODE' | translate }}</td><td>{{ agentDiagnostics.reasonCode }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.PEP_SANCTIONS' | translate }}</td><td>{{ agentDiagnostics.pepSanctions === null ? ('KYC.AGENT_DIAGNOSTICS.NOT_CHECKED' | translate) : agentDiagnostics.pepSanctions ? ('KYC.AGENT_DIAGNOSTICS.YES' | translate) : ('KYC.AGENT_DIAGNOSTICS.NO' | translate) }}</td></tr>
        </table>
        <details>
          <summary>{{ 'KYC.AGENT_DIAGNOSTICS.RAW_NOTES' | translate }}</summary>
          <pre>{{ agentDiagnostics.rawNotes }}</pre>
        </details>
        <div class="agent-actions">
          <h4>{{ 'KYC.AGENT_ACTIONS.TITLE' | translate }}</h4>
          <button class="def-button alt" (click)="onAgentBypassKyc()" [disabled]="agentActionLoading">
            <mat-icon *ngIf="agentActionLoading === 'bypass'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.BYPASS_KYC' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer central">
      <button class="def-button" *ngIf="!data.isComponentView" (click)="close()">
        {{ "Close" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- STEP 10: ERROR -->
  <ng-container *ngIf="steps === 'ERROR'">
    <div class="container status error">
      <mat-icon>error</mat-icon>
      <h3 class="title">
        {{ getCurrentErrorMessage() | translate }}
      </h3>
      <!-- error-message: only render when it differs from the title to avoid
           rendering the same text twice (which was happening for Veriff reason
           codes where `currentError.code` and `currentError.message` resolve
           to the same translation string). -->
      <p class="error-message"
         *ngIf="currentError?.message && currentError!.message !== (getCurrentErrorMessage() | translate)">
        {{ currentError!.message }}
      </p>
      <p class="suggested-action" *ngIf="currentError?.suggestedAction">
        {{ currentError!.suggestedAction }}
      </p>

      <!-- Inline action buttons — placed high in the layout so they stay
           visible without scrolling on mobile/tablet viewports. -->
      <div class="error-actions">
        <button
          *ngIf="currentError?.canRetry && !currentError?.shouldWait"
          class="def-button"
          (click)="processError()">
          {{ "TryAgain" | translate }}
        </button>
      </div>

      <!-- Retry limit info -->
      <div *ngIf="currentError?.currentRetries !== undefined && currentError?.maxRetries !== undefined"
           class="retry-limit-info">
        <mat-icon>info</mat-icon>
        <span>
          {{ "Verification attempts" | translate }}:
          {{ currentError!.currentRetries }} / {{ currentError!.maxRetries }}
        </span>
      </div>

      <!-- Wait timer display -->
      <div *ngIf="currentError?.shouldWait && isWaitTimeActive()" class="wait-timer">
        <mat-icon>schedule</mat-icon>
        <span>{{ "Please wait" | translate }}: {{ formatWaitTime() }}</span>
      </div>
      <details *ngIf="isAgentSession && currentError && currentError.technicalDetails" class="technical-details">
        <summary>{{ "Technical Details" | translate }}</summary>
        <pre>{{ currentError.technicalDetails }}</pre>
      </details>

      <p class="faq-link">
        {{ "NeedHelp?CheckOur" | translate }} <a (click)="goToFaq()">FAQ</a>
      </p>

      <!-- Agent Diagnostic Panel (only visible during impersonation) -->
      <div *ngIf="isAgentSession && agentDiagnostics" class="agent-diagnostic-panel">
        <h4>{{ 'KYC.AGENT_DIAGNOSTICS.TITLE' | translate }}</h4>
        <table>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.ERROR_CODE' | translate }}</td><td>{{ agentDiagnostics.errorCode }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.REASON_CODE' | translate }}</td><td>{{ agentDiagnostics.reasonCode }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.PROVIDER' | translate }}</td><td>{{ agentDiagnostics.provider }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.RETRIES' | translate }}</td><td>{{ agentDiagnostics.retries }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.PEP_SANCTIONS' | translate }}</td><td>{{ agentDiagnostics.pepSanctions === null ? ('KYC.AGENT_DIAGNOSTICS.NOT_CHECKED' | translate) : agentDiagnostics.pepSanctions ? ('KYC.AGENT_DIAGNOSTICS.YES' | translate) : ('KYC.AGENT_DIAGNOSTICS.NO' | translate) }}</td></tr>
          <tr><td>{{ 'KYC.AGENT_DIAGNOSTICS.NOTES_COUNT' | translate }}</td><td>{{ agentDiagnostics.notesCount }}</td></tr>
        </table>
        <details>
          <summary>{{ 'KYC.AGENT_DIAGNOSTICS.RAW_NOTES' | translate }}</summary>
          <pre>{{ agentDiagnostics.rawNotes }}</pre>
        </details>
        <div class="agent-actions">
          <h4>{{ 'KYC.AGENT_ACTIONS.TITLE' | translate }}</h4>
          <button class="def-button" (click)="onAgentIncreaseRetries()" [disabled]="agentActionLoading">
            <mat-icon *ngIf="agentActionLoading === 'retries'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.INCREASE_RETRIES' | translate }}
          </button>
          <button class="def-button alt" (click)="onAgentBypassKyc()" [disabled]="agentActionLoading">
            <mat-icon *ngIf="agentActionLoading === 'bypass'">hourglass_empty</mat-icon>
            {{ 'KYC.AGENT_ACTIONS.BYPASS_KYC' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer central">
      <!-- Close/Leave button (always available if not component view) -->
      <!-- TryAgain lives inline above (inside the error container) so it
           stays visible on small viewports — don't duplicate it here. -->
      <button class="def-button alt" *ngIf="!data.isComponentView" (click)="close()">
        {{ "Leave" | translate }}
      </button>
    </div>
  </ng-container>

<!-- Provider-specific test controls -->
  <ng-content select="[provider-test-controls]"></ng-content>
  </ng-container>
</div>
